import React from "react";
import VideoPlayer from "../components/VideoPlayer";

const Player = () => <VideoPlayer />;

export default Player;
